import React from "react";
import moment, { Moment } from "moment-timezone";

export interface NewsArticleProps {
  headline: string;
  datePublished: string;
  dateModified: string;
  author: string;
  image: string[] | string;
  description: string;
  articleBody: string;
  articleSection: string;
  keywords: string[];
  pathname: string;
  hasAccess?: boolean;
}

export const NewsArticleSchema = ({
  headline, // title
  articleBody,
  articleSection,
  datePublished = moment().toISOString(),
  dateModified = datePublished,
  author,
  image, // article's image in 1x1, 4x3, 16x9
  description, // start of article
  keywords,
  pathname,
  hasAccess = true,
}: NewsArticleProps) => {
  const paywallSchema = hasAccess
    ? {}
    : {
        isAccessibleForFree: "False",
        hasPart: {
          "@type": "WebPageElement",
          isAccessibleForFree: "False",
          cssSelector: ".rotoql-content-article__paywall-content",
        },
      };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "http://schema.org",
          "@type": "NewsArticle",
          mainEntityOfPage: {
            "@type": "WebPage",
            "@id": `https://betql.co${pathname}`,
          },
          headline,
          articleBody,
          description,
          articleSection,
          url: `https://betql.co${pathname}`,
          dateCreated: datePublished,
          datePublished: datePublished,
          dateModified: dateModified,
          author: {
            "@type": "Person",
            name: author,
          },
          publisher: {
            name: "BetQL",
            "@type": "Organization",
            logo: {
              "@type": "ImageObject",
              url: "https://betql.co/ogimage.jpg",
              width: 1200,
              height: 630,
            },
            url: "https://betql.co",
          },
          image: Array.isArray(image) ? image : [image],
          keywords,
          ...paywallSchema,
        }),
      }}
    />
  );
};

export interface SportsEventProps {
  keywords: string[];
  pathname: string;
  awayTeam: string;
  homeTeam: string;
  sport: string;
  location: string;
  startDate: Moment;
}

export const SportingEventSchema = ({
  keywords,
  pathname,
  awayTeam,
  homeTeam,
  sport,
  location,
  startDate,
}: SportsEventProps) => {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "http://schema.org",
          "@type": "SportsEvent",
          mainEntityOfPage: {
            "@type": "WebPage",
            "@id": `https://betql.co${pathname}`,
          },
          name: "SportingEvent",
          awayTeam,
          homeTeam,
          sport,
          location,
          startDate,
          keywords,
        }),
      }}
    />
  );
};
